module.exports = __webpack_public_path__ + "img/ESG_folyamatabra_mobilra.b39441b3.png";